import { useEffect, useRef, useState } from 'react';

const VELOCIDADES = [0.25, 0.5, 1] as const;
/** Sem o fps da camera no aparelho, um quadro de 30 fps: o passo fino o bastante para ver o apoio. */
const QUADRO_S = 1 / 30;

/**
 * Video de marcha para analise: camera lenta e quadro a quadro. A dissociacao
 * e a regularidade do andamento aparecem no apoio de cada casco, que em
 * velocidade normal dura uma fracao de segundo. Teclas: "," e "." andam um
 * quadro (e pausam o video).
 */
export function PlayerDeMarcha({ url, titulo }: { url: string; titulo: string }) {
  const video = useRef<HTMLVideoElement>(null);
  const [velocidade, setVelocidade] = useState<(typeof VELOCIDADES)[number]>(1);

  useEffect(() => {
    if (video.current) video.current.playbackRate = velocidade;
  }, [velocidade]);

  const quadro = (sentido: 1 | -1) => {
    const v = video.current;
    if (!v) return;
    v.pause();
    v.currentTime = Math.max(0, Math.min(v.duration || Infinity, v.currentTime + sentido * QUADRO_S));
  };

  useEffect(() => {
    const tecla = (e: KeyboardEvent) => {
      const alvo = e.target as HTMLElement | null;
      if (alvo?.closest('input, textarea, select, [contenteditable]')) return;
      if (e.key === ',') quadro(-1);
      else if (e.key === '.') quadro(1);
      else return;
      e.preventDefault();
    };
    window.addEventListener('keydown', tecla);
    return () => window.removeEventListener('keydown', tecla);
  }, []);

  const botao = (ativo: boolean) =>
    `min-h-9 rounded-(--radius-controle) px-3 text-sm font-medium ${ativo ? 'bg-gelo text-abismo' : 'text-nevoa hover:bg-gelo/10'}`;

  return (
    <div className="bg-abismo">
      <video ref={video} src={url} controls playsInline preload="metadata" aria-label={titulo} className="aspect-video w-full" />
      <div className="flex flex-wrap items-center gap-1 px-3 py-2 text-nevoa">
        <span className="mr-1 text-xs tracking-wide uppercase">Velocidade</span>
        {VELOCIDADES.map((v) => (
          <button key={v} type="button" aria-pressed={velocidade === v} onClick={() => setVelocidade(v)} className={botao(velocidade === v)}>
            {v === 1 ? '1×' : `${String(v).replace('.', ',')}×`}
          </button>
        ))}
        <span className="mx-2 h-5 w-px bg-nevoa/30" aria-hidden />
        <button type="button" onClick={() => quadro(-1)} className={botao(false)} title="Quadro anterior (tecla ,)">
          ◀ quadro
        </button>
        <button type="button" onClick={() => quadro(1)} className={botao(false)} title="Próximo quadro (tecla .)">
          quadro ▶
        </button>
      </div>
    </div>
  );
}
